import { ChangeDetectionStrategy, Component, Input, ViewChild, OnInit, HostListener } from '@angular/core';
import { IonNav, ModalController } from '@ionic/angular';
import { ActivityType, Activity } from '@omni/classes/activity/activity.class';
import { ActivitiesDetailsPaneComponent } from '../activity/activities-details-pane/activities-details-pane';

@Component({
  selector: 'go-app-activity-details',
  templateUrl: './go-app-activity-details.component.html',
  styleUrl: './go-app-activity-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GoAppActivityDetailsComponent implements OnInit {

  @Input() type: ActivityType | 'Calendar Invite' | 'EventNote';
  @Input() viewData: any;
  @Input() from: string;
  @Input() activity: Activity;

  @ViewChild("activityDetailsNav", {static:true}) navCtrl: IonNav;

  constructor(
    private modalCtrl: ModalController
  ) {
  }

  ngOnInit() {
    if (this.activity) this.type = this.activity.type;
    switch (this.type) {
      case ActivityType.Appointment:
        this.navCtrl.setRoot(ActivitiesDetailsPaneComponent)
        break;
      default:
        break;
    }
  }

  // Listen for ESC key to dismiss modal
  @HostListener('document:keydown.escape', ['$event'])
  handleEscapeKey(event: KeyboardEvent) {
    this.dismissModal();
  }

  // Method to dismiss the modal
  dismissModal() {
    this.modalCtrl.dismiss();
  }

  ngOnDestroy() { 
    // Cleanup component
  }
}
